/* eslint-disable prettier/prettier */
// src/modules/owner/pages/actions/tanqueCheio/components/ResultsModal.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  InputAdornment,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { 
  Visibility, 
  Group, 
  TrendingUp, 
  BarChart,
  AttachMoney,
  AccountBalanceWallet,
  Search,
  PictureAsPdf,
  TableChart,
  Description
} from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import AlertDialogSlide from 'common/components/dialog/dialog';
import { isMobile } from 'react-device-detect';
import {
  ResultsStatCard,
  ResultsExportButton,
  ResultsPaginationContainer
} from './styles';

const ResultsModal = ({ open, onClose, activity }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [participants] = useState([
    {
      id: 1,
      name: 'Luigui Paccine',
      views: 5,
      participation: 'Visualizou',
      email: 'paccine.dev@gmail.com',
      details: 'Ainda não participou'
    }
  ]);

  // Dados mockados para demonstração
  const stats = {
    impressions: 5,
    reach: 1,
    participations: 0,
    conversion: 0.0,
    currentSpend: 0.00,
    remainingCashback: 0.00
  };

  const StatCard = ({ icon, title, value, color = '#4285f4' }) => (
    <ResultsStatCard>
      <div className="icon">
        {icon}
      </div>
      <div className="title">
        {title}
      </div>
      <div className="value">
        {value}
      </div>
      <div className="help-icon">
        ?
      </div>
    </ResultsStatCard>
  );

  const filteredParticipants = participants.filter(p =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AlertDialogSlide
      visible={open}
      onClose={onClose}
      title={`${activity?.name || 'Tanque Cheio Finale'} (08/10 - Hoje)`}
      maxWidth="lg"
      height="95vh"
    >
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 3 }}>
            Resultados gerais
          </Typography>
          
          <Grid container spacing={2} sx={{ mb: 4 }}>
            <Grid item xs={12} md={4}>
              <StatCard
                icon={<Visibility sx={{ fontSize: 40 }} />}
                title="Impressões"
                value={stats.impressions}
                color="#4285f4"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StatCard
                icon={<Group sx={{ fontSize: 40 }} />}
                title="Alcance"
                value={stats.reach}
                color="#4285f4"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StatCard
                icon={<TrendingUp sx={{ fontSize: 40 }} />}
                title="Participações"
                value={stats.participations}
                color="#4285f4"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 4 }}>
            <Grid item xs={12} md={4}>
              <StatCard
                icon={<BarChart sx={{ fontSize: 40 }} />}
                title="Conversão"
                value={`${stats.conversion}%`}
                color="#4285f4"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StatCard
                icon={<AttachMoney sx={{ fontSize: 40 }} />}
                title="Gasto atual"
                value={`R$${stats.currentSpend.toFixed(2)}`}
                color="#4285f4"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StatCard
                icon={<AccountBalanceWallet sx={{ fontSize: 40 }} />}
                title="Cashback restante"
                value={`R$${stats.remainingCashback.toFixed(2)}`}
                color="#4285f4"
              />
            </Grid>
          </Grid>

          {/* Botões de exportação */}
          <Box sx={{ display: 'flex', gap: 1, mb: 3, justifyContent: 'flex-end' }}>
            <ResultsExportButton className="pdf">
              <PictureAsPdf />
            </ResultsExportButton>
            <ResultsExportButton className="excel">
              <TableChart />
            </ResultsExportButton>
            <ResultsExportButton className="word">
              <Description />
            </ResultsExportButton>
          </Box>
        </Box>

        {/* Tabela de participantes */}
        <Box>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Extrato
          </Typography>
          
          <TextField
            placeholder="Procurar por nome de usuário"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 2, maxWidth: 300 }}
          />

          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Visualizações</TableCell>
                <TableCell>Participação</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Detalhes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredParticipants.map((participant) => (
                <TableRow key={participant.id}>
                  <TableCell>{participant.name}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Visibility sx={{ fontSize: 16 }} />
                      {participant.views}
                    </Box>
                  </TableCell>
                  <TableCell>{participant.participation}</TableCell>
                  <TableCell>{participant.email}</TableCell>
                  <TableCell>{participant.details}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <ResultsPaginationContainer>
            <div className="left">
              Linhas por página: 5
            </div>
            <div className="right">
              <div className="info">
                1 - 1 de 1
              </div>
              <div className="buttons">
                <button disabled>{'<<'}</button>
                <button disabled>{'<'}</button>
                <button disabled>{'>'}</button>
                <button disabled>{'>>'}</button>
              </div>
            </div>
          </ResultsPaginationContainer>
        </Box>
    </AlertDialogSlide>
  );
};

ResultsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  activity: PropTypes.object,
};

export default ResultsModal;
